function waitFor(milliseconds) {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
}

export default function retry(
    call,
    onRetry = () => {},
    maxRetries = 10,
    interval = 500,
    retryOnlyOn500s = false
) {
    async function _retry(retries) {
        try {
            if (retries > 0) {
                await waitFor(interval);
            }

            return await call();
        } catch (e) {
            // interceptors reject with `{ status }`, raw axios errors carry `response.status`
            const status = e?.status ?? e?.response?.status;
            if (retryOnlyOn500s && status && status < 500) {
                throw e;
            }

            if (retries < maxRetries) {
                onRetry();
                return _retry(retries + 1);
            }

            console.warn('Max retries reached.');
            throw e;
        }
    }

    return _retry(0);
}
